import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-empty-cart',
    templateUrl: './empty-cart.component.html',
    styleUrls: ['./empty-cart.component.scss'],
    standalone: false,
})
export class EmptyCartComponent {
    public emptyMessage: string;

    @Input() set emptyCartMessage(message: string | undefined) {
        this.emptyMessage =
            message != null ? message : 'To make a new payment, you must first search by MAWB and select charges.';
    }

    constructor(private _router: Router) {}

    back(): void {
        this._router.navigate(['/']);
    }
}
